import { render, staticRenderFns } from "./ControlWidgets.vue?vue&type=template&id=719bf010&scoped=true"
import script from "./ControlWidgets.vue?vue&type=script&lang=js"
export * from "./ControlWidgets.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgets.vue?vue&type=style&index=0&id=719bf010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719bf010",
  null
  
)

export default component.exports